import React, {  useState, useEffect  } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';

const SidebarMenu = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(window.innerWidth > 768);



   // Agregamos un listener para cambios en el tamaño de la ventana
   useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setIsOpen(true);
      } else {
        setIsOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);

    // Limpiamos el listener cuando el componente se desmonte
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  return (
    <div>
      {/* Botón para alternar la visibilidad del menú */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="text-white fixed top-5 left-5 z-50"
        aria-label="Toggle Menu"
      >
        <FontAwesomeIcon icon={faBars} />
      </button>

      {/* Menú lateral */}
      <div className={`w-64 h-full fixed left-0 top-0 bg-gray-800 text-white transition-all duration-300 ${isOpen ? 'translate-x-0' : '-translate-x-full'}`}>
        <br></br>
      <div className="p-4">
          {/*   <h2 className="text-lg font-bold"> M e n ú </h2>   */}
          <button className="block w-full text-left py-2 hover:bg-gray-600 transition" onClick={() => navigate("/autocreate")}>Registrar Líder</button>
          <button className="block w-full text-left py-2 hover:bg-gray-600 transition" onClick={() => navigate("/AdminLideres")}>Gestor de Líderes</button>
          <button className="block w-full text-left py-2 hover:bg-gray-600 transition" onClick={() => navigate("/adminEventos")}>Eventos</button>
          {/* <button className="block w-full text-left py-2 hover:bg-gray-600 transition" onClick={() => navigate("/ConsultaEventosMasivos")}>Consultar Eventos Masivos</button>  */}
          <button className="block w-full text-left py-2 hover:bg-gray-600 transition" onClick={() => navigate("/adminAuditoria")}>Eventos Auditados</button>
          <button className="block w-full text-left py-2 hover:bg-gray-600 transition" onClick={() => navigate("/estructuraNiveles")}>Estructura por Niveles</button>
          <button className="block w-full text-left py-2 hover:bg-gray-600 transition" onClick={() => navigate("/AdminNiveles")}>Niveles</button>

        </div>
      </div>
    </div>
  );
};

export default SidebarMenu;





